// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search_sys_body_result_resultarea_sec_sys2[data-v-86323df4]{width:calc(20% - 20px)}.search_sys_body_result_resultarea_sec_name[data-v-86323df4]{word-break:break-all;margin:4px 0 0;line-height:110%;font-weight:700;font-size:x-small;text-align:left}@media screen and (max-width:1279px){.search_sys_body_result_resultarea_sec_sys2[data-v-86323df4]{width:calc(50% - 10px);margin:10px 5px}}", ""]);
// Exports
module.exports = exports;
